var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#EE741F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4789 42.0422C33.848 42.0422 34.9578 43.152 34.9578 44.5211C34.9578 45.8902 33.848 47 32.4789 47C31.1098 47 30 45.8902 30 44.5211C30 43.152 31.1098 42.0422 32.4789 42.0422ZM32.4789 17C33.5499 17 34.43 17.7579 34.5298 18.7269L34.5392 18.911V35.6903C34.5392 36.7457 33.6168 37.6012 32.4789 37.6012C31.408 37.6012 30.5279 36.8433 30.428 35.8743L30.4186 35.6903V18.911C30.4186 17.8556 31.341 17 32.4789 17Z",
    fill: "#EE741F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationLight);
export default __webpack_public_path__ + "static/media/exclamation_light.d8c994cfdc36f0633c8e15d2383d9996.svg";
export { ForwardRef as ReactComponent };